import React from 'react'
import DialogInputLabel from './DialogInputLabel'
import CheckboxGroup from '@tencent/spaui-checkboxgroup'

const DialogUploadPlatformCheckboxGroup = ({ onChange, value, data, label = '包体位数', vertical = false }) => {
    return (
        <div className="track-body-item">
            <DialogInputLabel label={label} />
            <CheckboxGroup data={data} value={value} onChange={(e, val) => onChange(val)} />
        </div>
    )
}

export default DialogUploadPlatformCheckboxGroup
